import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import callGraphQL from "../models/graphql-api";
import { getCredentials, getCredentialsQuery } from "../models/Queries/GetCredentials";
import { selectCompany, setCredentials } from "../redux/slices/cleverlynkSlice";

export default function useCredentials() {
  const dispatch = useDispatch();
  const company = useSelector(selectCompany);

  useEffect(() => {
    const getDynamicCredentials = companyId => {
      getCredentialsQuery(
        callGraphQL<any>(getCredentialsQuery(companyId)).then(x => {
          const creds = getCredentials(x);
          if (creds.EC?.hasEC) {
            const script = document.createElement("script");
            script.src = "https://checkout.epayco.co/checkout.js";
            script.async = true;
            document.body.appendChild(script);
          }
          if (creds.WP?.hasWP) {
            const script = document.createElement("script");
            script.src = "https://checkout.wompi.co/widget.js";
            script.async = true;
            document.body.appendChild(script);
          }
          if (creds.PZ?.hasPZ) {
            const script1 = document.createElement("script");
            script1.src = "https://static.payzen.lat/static/js/krypton-client/V4.0/ext/classic.js";
            script1.async = true;

            const link = document.createElement("link");
            link.rel = "stylesheet";
            link.href = "https://static.payzen.lat/static/js/krypton-client/V4.0/ext/classic-reset.css";

            document.body.appendChild(script1);
            document.body.appendChild(link);
          }

          if (creds.RB?.hasRB) {
            const script1 = document.createElement("script");
            script1.src = "https://cdn.globalpay.com.co/ccapi/sdk/payment_checkout_2.0.0.min.js";
            script1.charset = "UTF-8";
            script1.async = true;

            document.body.appendChild(script1);
          } else if (creds.PT?.hasPT) {
            const script1 = document.createElement("script");
            script1.src = "https://cdn.paymentez.com/ccapi/sdk/payment_checkout_stable.min.js";
            script1.async = true;

            document.body.appendChild(script1);
          }

          if (creds.RP?.hasRP) {
            const script = document.createElement("script");
            script.src = "https://services.rappi.com/rms/merchant-services/sdk/v2/rms.js";
            script.async = true;
            script.crossOrigin = "anonymous";
            document.body.appendChild(script);
          }
          dispatch(setCredentials({ credentials: creds }));
        })
      );
    };

    if (company?.id) {
      getDynamicCredentials(company?.id);
    }
  }, [company]);
}
